import React from "react";
import {Navbar, Nav} from 'react-bootstrap';
import DashboardsNav from "../base/DashboardsNav";

import RespUtils from "../util/RespUtils";

class NavigationBar extends React.Component {
  constructor(props) {
		super(props);

		this.state = {
      username: "",
		};
	}

	async componentDidMount() {
	}

  showSettings (event) {
    event.preventDefault();
  }

  render() {
    // let logoWidth = (window.innerWidth < 600) ? 80: 120;
    // let logoHeight = (window.innerWidth < 600) ? 14:32;
    let logoWidth = (window.innerWidth < 600) ? 14: 32;
    let logoHeight = (window.innerWidth < 600) ? 14:32;

    return (
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
        <Navbar.Brand href="/"><img src="/images/logo/iotex_logo.png" width={logoWidth}
          height={logoHeight} className="d-inline-block align-top" alt="IoTeX Analytics"
          />&nbsp;IoTeX Analytics {this.getSS()}</Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link eventKey={1.12} href="/">Delegates</Nav.Link>
            <Nav.Link eventKey={1.13} href="https://d14n.smartstake.io/?ref=iotex">Decentralization</Nav.Link>
            <DashboardsNav />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }

  getSS() {
    if(RespUtils.isMobileView()) {
      return <font size="2">Smart Stake</font>
    }

    return <small>by Smart Stake</small>
  }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/iotex/NavigationBar.js